import { MDBBtn, MDBCheckbox, MDBModalBody, MDBModalFooter, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

function UserUpdateWarnings(props) {
    const [warnings, setwarnings] = useState([]);
    const [checkWarnings, setcheckWarnings] = useState([]);
    const [billingWarnings, setbillingWarnings] = useState({});
    const [selectedFids, setSelectedFids] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [note, setnote] = useState("");
    const { t, i18n } = useTranslation();


    useEffect(() => {
        if (props.warningsList && props.warningsList.length > 0) {
            let warningss = [];
            setTotalPrice(0);
            setSelectedFids([]);
             let checkedlist = [];
            props.warningsList.forEach((element) => {
                if (element.param_name === "checkbox") {
                     checkedlist = element.message.length > 0 ? [...element.message] : [];
                } else if (element.param_name === "billingInfo") {
                    setbillingWarnings(element.message);
                } else if (element.param_name === "Note") {
                    setnote(element.message);

                } else {
                    warningss.push(element);
                }

            });
            if (checkedlist.length > 0) {
                setcheckWarnings(checkedlist);
            } else {
                setcheckWarnings([]);
            }
            if (warningss.length > 0) {
                setwarnings(warningss);
            } else {
                setwarnings([]);
            }



        }

    }, [props.warningsList]);

    const handleCheckboxChange = (fid, price) => {

        const isAlreadySelected = selectedFids.includes(parseInt(fid));
        const newSelectedFids = isAlreadySelected
            ? selectedFids.filter((id) => parseInt(id) !== parseInt(fid))
            : [...selectedFids, parseInt(fid)];
        const newTotalPrice = isAlreadySelected
            ? totalPrice - price
            : totalPrice + price;

        setTotalPrice(newTotalPrice);
        setSelectedFids(newSelectedFids);
        
    };

    const handleConfirm = () => {
        if (props.modifiedDataJSon && Object.keys(props.modifiedDataJSon).length > 0) {
            const modifiedData = props.modifiedDataJSon;
            if (selectedFids.length > 0) {
                if (modifiedData?.seatplan_info) {
                    modifiedData.seatplan_info.added_addons = selectedFids;
                }

            }
            modifiedData.confirm = true;
            // console.log("final json request " + JSON.stringify(modifiedData));
            props.sendAPIRequest(modifiedData);
            props.onClose();

        }
    }

    return (
        <>
            <MDBModalBody>
                <MDBTable  bordered >
                    <MDBTableHead>
                        <tr>
                            <th className="w-30" scope="col">
                                Component
                            </th>
                            <th className="w-70" scope="col">
                                Description
                            </th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                        {warnings && warnings.length > 0 && warnings.map((warn) => (
                            <tr>
                                <td className="w-30">{t(warn.param_name)}</td>
                                <td className="w-70">
                                    <ul>
                                        {warn?.message?.map((messag) => (
                                            <li>
                                                <p>
                                                    {messag}
                                                </p>
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                            </tr>
                        ))}
                    </MDBTableBody>
                </MDBTable>
                {checkWarnings && checkWarnings.length > 0 && checkWarnings.map((warn, index) => {
                    const fid = Object.keys(warn)[0];
                    const service = Object.values(warn)[0];
                    const price = warn.price;

                    return (
                        <div className="my-3">

                            <MDBCheckbox
                                id="controlledCheckbox"
                                label={service}
                                checked={selectedFids.includes(parseInt(fid))}
                                onChange={() => handleCheckboxChange(fid, price)}
                            />

                        </div>
                    );
                })}


                <div>
                    <ul>
                        {Object.entries(billingWarnings).map(([key, value], index) => (
                            <li key={index}>
                                {value}
                            </li>
                        ))}

                    </ul>
                </div>
                <div>
                    {note?
                   <> <b> NOTE:</b> {note}</> :""}
                </div>

                {/* <div className="text-danger text-small">
                    With this action, User will lose access to Unified
                    Communications and its settings. Are you sure you want to
                    continue?
                </div> */}
            </MDBModalBody>

            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    No
                </MDBBtn>
                <MDBBtn onClick={(e) => {
                    e.preventDefault();
                    handleConfirm();
                }}>Yes</MDBBtn>
            </MDBModalFooter>

        </>
    )
}

export default UserUpdateWarnings
